import React from "react";
import "./App.css";
import Hero from "./components/Hero";
import GridView from "./components/Grid";
import { CssBaseline } from "@material-ui/core";
import Cover from "./components/Cover";
import Footer from "./components/Footer";
import ImageCarousel from "./components/Carousel";

const App = () => {
  return (
    <div>
      <CssBaseline />
      <Hero />
      <Cover />
      <GridView />
      {/* <ImageCarousel /> */}
      <Footer />
    </div>
  );
};

export default App;
